export default [
  {
    path: '/consulting-subscribe-order',
    name: 'consulting-subscribe-order',
    component: resolve => require(['views/consulting-subscribe-order'], resolve),
    meta: { auth: true, view: 'pc' }
  },
  {
    path: '/consulting-subscribe-order/work-order-detail/:id',
    name: 'work-order-detail',
    component: resolve => require(['views/work-order-detail'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '咨询商品预约工单/预约详情' }
  },
  {
    path: '/consulting-subscribe-order/work-order-history',
    name: 'work-order-history',
    component: resolve => require(['views/work-order-history'], resolve),
    meta: { auth: true, view: 'pc', navInfo: '咨询商品预约工单/咨询商品预约工单导出历史' }
  }
]
